export const wrapper = () => ({
    padding: '184px 24px 204px',
});
